const STORAGE_KEY = 'subscribe-popup-dismissed';
const SUBMITTED_KEY = 'subscribe-popup-submitted';

/**
 * Popup de suscripción: aparece tras un retraso, envía el correo al formulario
 * de cliente de Shopify y aplica el código de descuento de bienvenida.
 */
class SubscribePopup extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    this.form = this.querySelector('form');
    if (!this.dialog || !this.form) return;

    this.querySelectorAll('[data-close]').forEach((el) => el.addEventListener('click', () => this.close()));
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.close();
    });
    this.form.addEventListener('submit', (event) => this.submit(event));
    this.querySelector('[data-copy]')?.addEventListener('click', (event) => {
      navigator.clipboard?.writeText(event.currentTarget.dataset.copy).catch(() => {});
      event.currentTarget.textContent = '¡Copiado!';
    });

    // Shopify regresa a la página con ?customer_posted=true cuando el registro fue exitoso.
    if (new URLSearchParams(window.location.search).get('customer_posted') === 'true') {
      // Solo mostramos el código si el registro salió de este popup (y no del footer).
      let fromPopup = false;
      try {
        fromPopup = sessionStorage.getItem(SUBMITTED_KEY) === '1';
        sessionStorage.removeItem(SUBMITTED_KEY);
      } catch {}
      if (fromPopup) this.showSuccess();
      return;
    }

    if (this.dismissed() || Shopify.designMode) return;
    setTimeout(() => {
      if (document.querySelector('dialog[open]')) return;
      this.dialog.showModal();
      this.dialog.querySelector('[data-close]')?.blur();
    }, Number(this.dataset.delay || 2) * 1000);
  }

  async showSuccess() {
    history.replaceState(null, '', window.location.pathname);
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch {}
    this.querySelector('[data-state="form"]').hidden = true;
    this.querySelector('[data-state="success"]').hidden = false;
    this.dialog.showModal();
    this.dialog.querySelector('[data-close]')?.blur();
    if (this.dataset.code) await fetch(this.dataset.discountUrl).catch(() => {});
  }

  dismissed() {
    try {
      return Boolean(localStorage.getItem(STORAGE_KEY));
    } catch {
      return false;
    }
  }

  close() {
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch {}
    this.dialog?.close();
  }

  submit() {
    try {
      sessionStorage.setItem(SUBMITTED_KEY, '1');
    } catch {}
    // Shopify pide el teléfono con lada internacional: 10 dígitos => +52.
    const phone = this.form.querySelector('input[type="tel"]');
    const digits = phone.value.replace(/\D/g, '');
    if (digits.length === 10) phone.value = `+52${digits}`;
    else if (digits.length > 10) phone.value = `+${digits}`;

    // El formulario de suscripción de Shopify no guarda el teléfono en el cliente,
    // así que lo guardamos también como etiqueta (tel-+52...) visible en su ficha.
    const tags = this.form.querySelector('input[name="contact[tags]"]');
    if (tags && phone.value) tags.value = `${tags.value},tel-${phone.value.replace(/[^\d+]/g, '')}`;

    // Envío normal del formulario: así Shopify agrega su token anti-spam.
    this.form.querySelector('button[type="submit"]').disabled = true;
  }
}

if (!customElements.get('subscribe-popup')) customElements.define('subscribe-popup', SubscribePopup);
